import InventoriesPage from "./InventoryTypePage";
import DeliveryPage from "./DeliveryPage";
import UserPage from "./UserPage";
import AuthenticationPage from "./AuthenticationPage";
import React from "react";

export default function CoreModalPages(props) {
  return (
    <>
      <AuthenticationPage {...props} />
      <DeliveryPage {...props} />
      <UserPage {...props} />
      <InventoriesPage {...props} />
    </>
  );
}
